(async () => {
  const el = document.getElementById('lpu-page-price')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/[town-translit]/lpu/[lpu-translit]/price/index.vue'),
    },
  ]

  await clientRender({ components })
})()
